(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var panels = header.querySelectorAll('[data-header-details]');
    panels.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        panels.forEach(function (o) { if (o !== d) o.open = false; });
        var input = d.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      });
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) panels.forEach(function (d) { d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      panels.forEach(function (d) {
        if (d.open) { d.open = false; var s = d.querySelector('summary'); if (s) s.focus(); }
      });
    });
    window.addEventListener('resize', function () {
      var drawer = header.querySelector('.hdr__drawer');
      if (drawer && window.innerWidth >= 990) drawer.open = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-gallery-track]');
      var slides = g.querySelectorAll('[data-gallery-slide]');
      var thumbs = g.querySelectorAll('[data-gallery-thumb]');
      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      var current = g.querySelector('[data-gallery-current]');
      if (!track || slides.length < 2) return;
      var index = -1;
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function update() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i === index) return;
        index = i;
        if (current) current.textContent = i + 1;
        thumbs.forEach(function (t, n) { if (n === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
      if (prev) prev.addEventListener('click', function () { go(Math.max(index, 0) - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.video-section__frame').forEach(function (frame) {
      var video = frame.querySelector('video');
      var btn = frame.querySelector('[data-video-toggle]');
      if (!video || !btn) return;
      function sync() {
        var paused = video.paused;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }
      if (reduce) { video.removeAttribute('autoplay'); video.pause(); }
      btn.addEventListener('click', function () { if (video.paused) { video.play(); } else { video.pause(); } });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
